import { makeImmutable } from "../core/makeImmutable";
export class PMenu {
    constructor(params) {
        this.domain = params.domain;
        this.sections = params.sections;
        makeImmutable(this);
    }
}
